// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================
   ADMIN LAYOUT
===================================== */

.admin-layout {
    display: flex;
  
    width: 100%;
    min-height: 100vh;
  
    background: #f6f7fb;
  }
  
  
  /* =====================================
     CONTENT WRAPPER
  ===================================== */
  
  .admin-content-wrapper {
    width: 100%;
    min-width: 0;
  
    margin-left: 260px;
  
    transition:
      margin-left 0.25s ease;
  }
  
  
  /* =====================================
     MAIN CONTENT
  ===================================== */
  
  .admin-main-content {
    width: 100%;
    min-width: 0;
  
    padding: 32px;
  
    box-sizing: border-box;
  }
  
  
  /* =====================================
     MOBILE HEADER
  ===================================== */
  
  .admin-mobile-header {
    display: none;
  }
  
  
  /* =====================================
     OVERLAY
  ===================================== */
  
  .admin-sidebar-overlay {
    display: none;
  }
  
  
  /* =====================================
     LARGE DESKTOP
  ===================================== */
  
  @media (min-width: 1440px) {
  
    .admin-main-content {
      padding: 40px;
    }
  
  }
  
  
  /* =====================================
     TABLET / SMALL LAPTOP
  ===================================== */
  
  @media (max-width: 1100px) {
  
    .admin-main-content {
      padding: 24px;
    }
  
  }
  
  
  /* =====================================
     MOBILE + TABLET
  ===================================== */
  
  @media (max-width: 900px) {
  
    .admin-content-wrapper {
      margin-left: 0;
    }
  
  
    .admin-mobile-header {
      position: sticky;
      top: 0;
  
      z-index: 800;
  
      display: flex;
      align-items: center;
      gap: 14px;
  
      height: 64px;
  
      padding: 0 20px;
  
      background:
        rgba(255, 255, 255, 0.96);
  
      border-bottom:
        1px solid #e8eaf0;
  
      backdrop-filter: blur(10px);
  
      box-sizing: border-box;
    }
  
  
    .admin-mobile-menu-button {
      width: 40px;
      height: 40px;
  
      display: flex;
      align-items: center;
      justify-content: center;
  
      flex-shrink: 0;
  
      border: 1px solid #e4e7ec;
      border-radius: 10px;
  
      background: #ffffff;
  
      color: #344054;
  
      font-size: 17px;
  
      cursor: pointer;
    }
  
  
    .admin-mobile-brand {
      display: flex;
      flex-direction: column;
      gap: 2px;
  
      min-width: 0;
    }
  
  
    .admin-mobile-brand strong {
      font-size: 16px;
      color: #101828;
    }
  
  
    .admin-mobile-brand span {
      font-size: 11px;
      color: #667085;
    }
  
  
    .admin-main-content {
      padding: 24px 20px;
    }
  
  
    .admin-sidebar-overlay {
      position: fixed;
      inset: 0;
  
      z-index: 1100;
  
      display: block;
  
      background:
        rgba(15, 23, 42, 0.48);
  
      backdrop-filter: blur(2px);
    }
  
  }
  
  
  /* =====================================
     MOBILE
  ===================================== */
  
  @media (max-width: 600px) {
  
    .admin-mobile-header {
      height: 60px;
  
      padding:
        0 14px;
    }
  
  
    .admin-mobile-menu-button {
      width: 38px;
      height: 38px;
    }
  
  
    .admin-main-content {
      padding:
        18px 14px 30px;
    }
  
  }
  
  
  /* =====================================
     VERY SMALL MOBILE
  ===================================== */
  
  @media (max-width: 380px) {
  
    .admin-main-content {
      padding:
        16px 10px 26px;
    }
  
  }`, "",{"version":3,"sources":["webpack://./src/admin/styles/AdminLayout.css"],"names":[],"mappings":"AAAA;;uCAEuC;;AAEvC;IACI,aAAa;;IAEb,WAAW;IACX,iBAAiB;;IAEjB,mBAAmB;EACrB;;;EAGA;;yCAEuC;;EAEvC;IACE,WAAW;IACX,YAAY;;IAEZ,kBAAkB;;IAElB;4BACwB;EAC1B;;;EAGA;;yCAEuC;;EAEvC;IACE,WAAW;IACX,YAAY;;IAEZ,aAAa;;IAEb,sBAAsB;EACxB;;;EAGA;;yCAEuC;;EAEvC;IACE,aAAa;EACf;;;EAGA;;yCAEuC;;EAEvC;IACE,aAAa;EACf;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE,aAAa;IACf;;EAEF;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE,aAAa;IACf;;EAEF;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE,cAAc;IAChB;;;IAGA;MACE,gBAAgB;MAChB,MAAM;;MAEN,YAAY;;MAEZ,aAAa;MACb,mBAAmB;MACnB,SAAS;;MAET,YAAY;;MAEZ,eAAe;;MAEf;iCAC2B;;MAE3B;yBACmB;;MAEnB,2BAA2B;;MAE3B,sBAAsB;IACxB;;;IAGA;MACE,WAAW;MACX,YAAY;;MAEZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;;MAEvB,cAAc;;MAEd,yBAAyB;MACzB,mBAAmB;;MAEnB,mBAAmB;;MAEnB,cAAc;;MAEd,eAAe;;MAEf,eAAe;IACjB;;;IAGA;MACE,aAAa;MACb,sBAAsB;MACtB,QAAQ;;MAER,YAAY;IACd;;;IAGA;MACE,eAAe;MACf,cAAc;IAChB;;;IAGA;MACE,eAAe;MACf,cAAc;IAChB;;;IAGA;MACE,kBAAkB;IACpB;;;IAGA;MACE,eAAe;MACf,QAAQ;;MAER,aAAa;;MAEb,cAAc;;MAEd;8BACwB;;MAExB,0BAA0B;IAC5B;;EAEF;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE,YAAY;;MAEZ;cACQ;IACV;;;IAGA;MACE,WAAW;MACX,YAAY;IACd;;;IAGA;MACE;sBACgB;IAClB;;EAEF;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE;sBACgB;IAClB;;EAEF","sourcesContent":["/* =====================================\n   ADMIN LAYOUT\n===================================== */\n\n.admin-layout {\n    display: flex;\n  \n    width: 100%;\n    min-height: 100vh;\n  \n    background: #f6f7fb;\n  }\n  \n  \n  /* =====================================\n     CONTENT WRAPPER\n  ===================================== */\n  \n  .admin-content-wrapper {\n    width: 100%;\n    min-width: 0;\n  \n    margin-left: 260px;\n  \n    transition:\n      margin-left 0.25s ease;\n  }\n  \n  \n  /* =====================================\n     MAIN CONTENT\n  ===================================== */\n  \n  .admin-main-content {\n    width: 100%;\n    min-width: 0;\n  \n    padding: 32px;\n  \n    box-sizing: border-box;\n  }\n  \n  \n  /* =====================================\n     MOBILE HEADER\n  ===================================== */\n  \n  .admin-mobile-header {\n    display: none;\n  }\n  \n  \n  /* =====================================\n     OVERLAY\n  ===================================== */\n  \n  .admin-sidebar-overlay {\n    display: none;\n  }\n  \n  \n  /* =====================================\n     LARGE DESKTOP\n  ===================================== */\n  \n  @media (min-width: 1440px) {\n  \n    .admin-main-content {\n      padding: 40px;\n    }\n  \n  }\n  \n  \n  /* =====================================\n     TABLET / SMALL LAPTOP\n  ===================================== */\n  \n  @media (max-width: 1100px) {\n  \n    .admin-main-content {\n      padding: 24px;\n    }\n  \n  }\n  \n  \n  /* =====================================\n     MOBILE + TABLET\n  ===================================== */\n  \n  @media (max-width: 900px) {\n  \n    .admin-content-wrapper {\n      margin-left: 0;\n    }\n  \n  \n    .admin-mobile-header {\n      position: sticky;\n      top: 0;\n  \n      z-index: 800;\n  \n      display: flex;\n      align-items: center;\n      gap: 14px;\n  \n      height: 64px;\n  \n      padding: 0 20px;\n  \n      background:\n        rgba(255, 255, 255, 0.96);\n  \n      border-bottom:\n        1px solid #e8eaf0;\n  \n      backdrop-filter: blur(10px);\n  \n      box-sizing: border-box;\n    }\n  \n  \n    .admin-mobile-menu-button {\n      width: 40px;\n      height: 40px;\n  \n      display: flex;\n      align-items: center;\n      justify-content: center;\n  \n      flex-shrink: 0;\n  \n      border: 1px solid #e4e7ec;\n      border-radius: 10px;\n  \n      background: #ffffff;\n  \n      color: #344054;\n  \n      font-size: 17px;\n  \n      cursor: pointer;\n    }\n  \n  \n    .admin-mobile-brand {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n  \n      min-width: 0;\n    }\n  \n  \n    .admin-mobile-brand strong {\n      font-size: 16px;\n      color: #101828;\n    }\n  \n  \n    .admin-mobile-brand span {\n      font-size: 11px;\n      color: #667085;\n    }\n  \n  \n    .admin-main-content {\n      padding: 24px 20px;\n    }\n  \n  \n    .admin-sidebar-overlay {\n      position: fixed;\n      inset: 0;\n  \n      z-index: 1100;\n  \n      display: block;\n  \n      background:\n        rgba(15, 23, 42, 0.48);\n  \n      backdrop-filter: blur(2px);\n    }\n  \n  }\n  \n  \n  /* =====================================\n     MOBILE\n  ===================================== */\n  \n  @media (max-width: 600px) {\n  \n    .admin-mobile-header {\n      height: 60px;\n  \n      padding:\n        0 14px;\n    }\n  \n  \n    .admin-mobile-menu-button {\n      width: 38px;\n      height: 38px;\n    }\n  \n  \n    .admin-main-content {\n      padding:\n        18px 14px 30px;\n    }\n  \n  }\n  \n  \n  /* =====================================\n     VERY SMALL MOBILE\n  ===================================== */\n  \n  @media (max-width: 380px) {\n  \n    .admin-main-content {\n      padding:\n        16px 10px 26px;\n    }\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
